

export class AllNotificationDto implements IAllNotificationDto {
    id!: number;
    title!: string | undefined;
    body!: string | undefined;
    typeName!: string | undefined;
    category!: string | undefined;
    icon!: string | undefined;
    isRead!: boolean;
    createdOn!: Date | undefined;
    pageName!: string | undefined;
    referenceNo!: string | undefined;

    constructor(data?: IAllNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.typeName = _data["typeName"];
            this.category = _data["category"];
            this.icon = _data["icon"];
            this.isRead = _data["isRead"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.pageName = _data["pageName"];
            this.referenceNo = _data["referenceNo"];
        }
    }

    static fromJS(data: any): AllNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["body"] = this.body;
        data["typeName"] = this.typeName;
        data["category"] = this.category;
        data["icon"] = this.icon;
        data["isRead"] = this.isRead;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["pageName"] = this.pageName;
        data["referenceNo"] = this.referenceNo;
        return data; 
    }
}

export interface IAllNotificationDto {
    id: number;
    title: string | undefined;
    body: string | undefined;
    typeName: string | undefined;
    category: string | undefined;
    icon: string | undefined;
    isRead: boolean;
    createdOn: Date | undefined;
    pageName: string | undefined;
    referenceNo: string | undefined;
}

